import { HttpMethods, makeRequest } from '../helpers/http.helper';
import { OrganizationRequest, UpdateOrganizationRequest, OrganizationQueryParams } from '../types/organization.type';

export const createOrganization = (organization: OrganizationRequest) => {
    return makeRequest({
        url: "/organization",
        method: HttpMethods.POST,
        data: organization,
    });
};

export const getOrganizations = (params?: OrganizationQueryParams) => {
    return makeRequest({
        url: "/organization",
        method: HttpMethods.GET,
        params: params || {},
    });
};

export const getOrganization = (organizationId: string) => {
    return makeRequest({
        url: `/organization/${organizationId}`,
        method: HttpMethods.GET,
    });
};

export const updateOrganization = (organizationId: string, organization: UpdateOrganizationRequest) => {
    return makeRequest({
        url: `/organization/${organizationId}`,
        method: HttpMethods.PUT,
        data: organization,
    });
};

export const deleteOrganization = (organizationId: string) => {
    return makeRequest({
        url: `/organization/${organizationId}`,
        method: HttpMethods.DELETE,
    });
};
